module.exports = __webpack_public_path__ + "img/brand.9f526e7c.svg";